export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "guides_tab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guides & modules"])},
        "stores_tab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivi magasins"])}
      },
      "en": {
        "guides_tab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guides & modules"])},
        "stores_tab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store follow-up"])}
      }
    }
  })
}
